import { render, staticRenderFns } from "./MenuManagementView.vue?vue&type=template&id=3993b43f&scoped=true"
import script from "./MenuManagementView.vue?vue&type=script&lang=js"
export * from "./MenuManagementView.vue?vue&type=script&lang=js"
import style0 from "./MenuManagementView.vue?vue&type=style&index=0&id=3993b43f&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3993b43f",
  null
  
)

export default component.exports